const IMAGE_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[imageManagementExperience] createImage',
  EDIT: '[imageManagementExperience] editImage',
  DELETE: '[imageManagementExperience] deleteImage'
}

export default IMAGE_MANAGEMENT_EXPERIENCE_TYPES
